import moment from "moment";
import * as React from "react";
import { toast } from "react-toastify";
import { Modal } from "reactstrap";
import InputField from "@_common/InputRuleFeild";
import {
	ConfigureCheckpointPECompliance,
	GetSpecificCheckpointPECompliance,
} from "@services/checkpoint.service";
import { getValue } from "@utils/lodash";
import "../configure.scss";
interface IConfigurePopupProps {
	isOpen: boolean;
	handleModal: () => void;
	selectedIDs: [];
	handleModalCancel: () => void;
	getDataRefetch: () => void;
	configureID: string;
	setConfigureID: any;
}

const ConfigurePopup: React.FunctionComponent<IConfigurePopupProps> = (
	props: any
) => {
	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */
	const [isLoading, setIsLoading] = React.useState(false);
	const [request, setRequest] = React.useState<any>({
		legal_due_date: null,
		pe_compliance_ids: [],
		frequency_type: "ONE_TIME",
		new_activity_range: "DAILY",
		once_in_every: "",
		on_day: "",
		on_month: "",
	});
	const [frequency] = React.useState([
		{ label: "One Time", value: "ONE_TIME" },
		{ label: "Recurring", value: "RECURRING" },
	]);

	const [activity_range] = React.useState([
		{ label: "Daily", value: "DAILY" },
		{ label: "Weekly", value: "WEEKLY" },
		{ label: "Monthly", value: "MONTHLY" },
		{ label: "Yearly", value: "YEARLY" },
	]);

	const [days, setDays] = React.useState<[] | any>([]);
	const [daysObject] = React.useState([
		{ label: "Sun", value: "1" },
		{ label: "Mon", value: "2" },
		{ label: "Tue", value: "3" },
		{ label: "Wed", value: "4" },
		{ label: "Thu", value: "5" },
		{ label: "Fri", value: "6" },
		{ label: "Sat", value: "7" },
	]);

	const [months] = React.useState([
		{ label: "1", value: "1" },
		{ label: "2", value: "2" },
		{ label: "3", value: "3" },
		{ label: "4", value: "4" },
		{ label: "5", value: "5" },
		{ label: "6", value: "6" },
		{ label: "7", value: "7" },
		{ label: "8", value: "8" },
		{ label: "9", value: "9" },
		{ label: "10", value: "10" },
		{ label: "11", value: "11" },
		{ label: "12", value: "12" },
	]);

	const [monthString] = React.useState([
		{ label: "Jan", value: "1" },
		{ label: "Feb", value: "2" },
		{ label: "Mar", value: "3" },
		{ label: "Apr", value: "4" },
		{ label: "May", value: "5" },
		{ label: "Jun", value: "6" },
		{ label: "Jul", value: "7" },
		{ label: "Aug", value: "8" },
		{ label: "Sep", value: "9" },
		{ label: "Oct", value: "10" },
		{ label: "Nov", value: "11" },
		{ label: "Dec", value: "12" },
	]);

	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */
	React.useEffect(() => {
		let array = [];
		for (let i = 0; i < 30; i++) {
			array.push({
				value: i + 1,
				label: i + 1,
			});
		}
		setDays(array);
	}, [props.permissionAPITriggered]);

	const handleCancel = () => {
		setRequest({
			...request,
			legal_due_date: null,
			pe_compliance_ids: [],
			frequency_type: "ONE_TIME",
			new_activity_range: "DAILY",
			once_in_every: "",
			on_day: "",
			on_month: "",
		});
		props.setConfigureID("");
		props.handleModal();
	};
	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */

	const handleSubmit = async () => {
		try {
			setIsLoading(true);
			let payload = JSON.parse(JSON.stringify(request));
			let obj: any = {
				legal_due_date: moment(getValue(payload, `legal_due_date`, "")).format(
					"YYYY-MM-DD"
				),
				pe_compliance_ids:
					getValue(props, `selectedIDs.length`, 0) > 0
						? getValue(props, `selectedIDs`, [])
						: [getValue(props, `configureID`, "")],
				frequency_type: getValue(payload, `frequency_type`, ""),
				new_activity_range: getValue(payload, `new_activity_range`, ""),
				once_in_every: parseInt(getValue(payload, `once_in_every`, "")),
				on_day: parseInt(getValue(payload, `on_day`, "")),
				on_month: parseInt(getValue(payload, `on_month`, "")),
			};
			Object.keys(obj).forEach((key) => {
				if (!obj[key] || obj[key] === undefined) {
					delete obj[key];
				}
			});
			let resp = await ConfigureCheckpointPECompliance(obj);
			if (resp) {
				setIsLoading(false);
				toast.success("Submitted successfully");
				props.handleModalCancel();
				props.getDataRefetch();
			} else {
				setIsLoading(false);
			}
		} catch (error) {
			setIsLoading(false);
		}
	};

	React.useEffect(() => {
		if (props.configureID) {
			getData(props.configureID);
		} else {
			setRequest({
				...request,
				legal_due_date: null,
				pe_compliance_ids: [],
				frequency_type: "ONE_TIME",
				new_activity_range: "DAILY",
				once_in_every: "",
				on_day: "",
				on_month: "",
			});
		}
	}, [props.configureID]);

	const getData = async (id: string) => {
		try {
			let resp = await GetSpecificCheckpointPECompliance(id);
			if (resp) {
				setRequest({
					...request,
					legal_due_date: getValue(resp, `data.legal_due_date`, "")
						? new Date(getValue(resp, `data.legal_due_date`, ""))
						: null,
					frequency_type: getValue(resp, `data.frequency_type`, ""),
					new_activity_range: getValue(resp, `data.new_activity_range`, ""),
					once_in_every: getValue(resp, `data.once_in_every`, ""),
					on_day: getValue(resp, `data.on_day`, ""),
					on_month: getValue(resp, `data.on_month`, ""),
				});
			} else {
				setRequest({
					...request,
					legal_due_date: null,
					pe_compliance_ids: [],
					frequency_type: "ONE_TIME",
					new_activity_range: "DAILY",
					once_in_every: "",
					on_day: "",
					on_month: "",
				});
			}
		} catch (error) {}
	};
	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */
	const tomorrowDate: any = moment().add(1, "days");
	let tomorrow: any = new Date(tomorrowDate);
	return (
		<Modal isOpen={props.isOpen} className="add-comments-popup-config" centered>
			<div className="config-modal-content">
				<div className="configure-wrapper__frequency d-flex align-items-center">
					<img
						src="/images/checkpoint/frequency.svg"
						className="configure-wrapper__frequency-icon img-fluid"
						alt="test"
					/>
					Frequency
				</div>
				<div className="configure-wrapper__form">
					<div className="d-flex align-items-center gap">
						{frequency.map((item: object, key: number) => {
							return (
								<div
									key={key}
									className={`configure-wrapper__task cursor-pointer ${
										getValue(item, `value`, "") ===
										getValue(request, `frequency_type`, "")
											? "active"
											: ""
									}`}
									onClick={() =>
										setRequest({
											...request,
											frequency_type: getValue(item, `value`, ""),
										})
									}
								>
									{getValue(item, `label`, "")}
								</div>
							);
						})}
					</div>
					{getValue(request, `frequency_type`, "") === "RECURRING" && (
						<div className="configure-wrapper__create-recuring-task form-group mt-3">
							<label className="configure-wrapper__create-label">
								Create New Copies
							</label>
							<div className="d-flex align-items-center">
								{activity_range.map((item: object) => {
									return (
										<div
											onClick={() =>
												setRequest({
													...request,
													new_activity_range: getValue(item, `value`, ""),
												})
											}
											className={`configure-wrapper__create-time ${
												getValue(item, `value`, "") ===
												getValue(request, `new_activity_range`, "")
													? "active"
													: ""
											}`}
										>
											{getValue(item, `label`, "")}
										</div>
									);
								})}
							</div>

							{getValue(request, "new_activity_range", "") === "DAILY" && (
								<div className="d-flex align-items-center grid">
									<label className="configure-wrapper__create-label">
										Every
									</label>
									<div className="d-flex align-items-center grid">
										<div className="input-grid-item">
											<InputField
												inputType="INPUT_REACT_SELECT_MODAL"
												className="configure-wrapper__form-control form-control m-0"
												value={days.filter(
													(item: any) =>
														item.value == getValue(request, `once_in_every`, "")
												)}
												options={days}
												onChange={(e: object) =>
													setRequest({
														...request,
														once_in_every: getValue(e, `value`, ""),
													})
												}
											/>
										</div>
										<p className="mx-2">day(s)</p>
									</div>
								</div>
							)}
							{getValue(request, "new_activity_range", "") === "WEEKLY" && (
								<>
									<div className="d-flex align-items-center mb-3">
										<label className="configure-wrapper__create-label">
											Every
										</label>
										<div className="d-flex align-items-center">
											<InputField
												inputType="INPUT_REACT_SELECT"
												options={days}
												value={days.filter(
													(item: any) =>
														item.value == getValue(request, `once_in_every`, "")
												)}
												onChange={(e: object) =>
													setRequest({
														...request,
														once_in_every: getValue(e, `value`, ""),
													})
												}
											/>
											<p className="mx-2">Weeks(s)</p>
										</div>
									</div>

									<div className="d-flex align-items-center form-group">
										<label className="configure-wrapper__create-label">
											On
										</label>
										<div className="d-flex align-items-center">
											<div className="configure-wrapper__form-control">
												<InputField
													inputType="INPUT_REACT_SELECT"
													options={daysObject}
													value={daysObject.filter(
														(item: any) =>
															item.value == getValue(request, `on_day`, "")
													)}
													onChange={(e: object) =>
														setRequest({
															...request,
															on_day: getValue(e, `value`, ""),
														})
													}
												/>
											</div>
											<p className="mx-2">Day</p>
										</div>
									</div>
								</>
							)}

							{getValue(request, "new_activity_range", "") === "MONTHLY" && (
								<>
									<div className="d-flex align-items-center form-group">
										<label className="configure-wrapper__create-label">
											Once In Every
										</label>
										<div className="d-flex align-items-center">
											<InputField
												inputType="INPUT_REACT_SELECT"
												options={months}
												value={months.filter(
													(item: any) =>
														item.value == getValue(request, `once_in_every`, "")
												)}
												onChange={(e: object) =>
													setRequest({
														...request,
														once_in_every: getValue(e, `value`, ""),
													})
												}
											/>

											<p className="mx-2">Months(s)</p>
										</div>
									</div>

									<div className="d-flex align-items-center form-group">
										<label className="configure-wrapper__create-label">
											On
										</label>
										<div className="d-flex align-items-center">
											<div className="configure-wrapper__form-control">
												<InputField
													inputType="INPUT_REACT_SELECT"
													options={days}
													value={days.filter(
														(item: any) =>
															item.value == getValue(request, `on_day`, "")
													)}
													onChange={(e: object) =>
														setRequest({
															...request,
															on_day: getValue(e, `value`, ""),
														})
													}
												/>
											</div>
											<p className="mx-2">Day</p>
										</div>
									</div>
								</>
							)}

							{getValue(request, "new_activity_range", "") === "YEARLY" && (
								<>
									<div className="d-flex align-items-center form-group">
										<label className="configure-wrapper__create-label">
											Once In Every
										</label>
										<div className="d-flex align-items-center">
											<InputField
												inputType="INPUT_REACT_SELECT"
												options={days}
												value={days.filter(
													(item: any) =>
														item.value == getValue(request, `once_in_every`, "")
												)}
												onChange={(e: object) =>
													setRequest({
														...request,
														once_in_every: getValue(e, `value`, ""),
													})
												}
											/>
											<p className="mx-2">Year(s)</p>
										</div>
									</div>
									<div className="d-flex align-items-center form-group ">
										<label className="configure-wrapper__create-label">
											On
										</label>
										<div className="d-flex align-items-center">
											<div className="configure-wrapper__form-control">
												<InputField
													inputType="INPUT_REACT_SELECT"
													options={monthString}
													value={monthString.filter(
														(item: any) =>
															item.value == getValue(request, `on_month`, "")
													)}
													onChange={(e: object) =>
														setRequest({
															...request,
															on_month: getValue(e, `value`, ""),
														})
													}
												/>
											</div>
											<p className="mx-2">Month(s)</p>
										</div>
									</div>

									<div className="d-flex align-items-center form-group ">
										<label className="configure-wrapper__create-label">
											On
										</label>
										<div className="d-flex align-items-center">
											<InputField
												inputType="INPUT_REACT_SELECT"
												options={days}
												value={days.filter(
													(item: any) =>
														item.value == getValue(request, `on_day`, "")
												)}
												onChange={(e: object) =>
													setRequest({
														...request,
														on_day: getValue(e, `value`, ""),
													})
												}
											/>

											<p className="mx-2">Day</p>
										</div>
									</div>
								</>
							)}
						</div>
					)}

					<div className="form-group cursor-pointer grid mt-2">
						<div className="position-relative input-grid-item">
							<label className="release-date-wrapper__vendor-label">
								Upcoming Legal Due Date
							</label>
							{/* <label onClick={(e) => e.preventDefault()}> */}
							<InputField
								inputType="DATETYPE-DOB-MODAL"
								value={getValue(request, `legal_due_date`, "")}
								className="form-control"
								onChange={(e: any) =>
									setRequest({
										...request,
										legal_due_date: e,
									})
								}
								minDate={
									getValue(request, `frequency_type`, "") !== "ONE_TIME" &&
									tomorrow
								}
								placeholderText={"Enter Legal Due Date"}
							/>
							<img
								src="/images/checkpoint/calender.svg"
								className="img-fluid form-image form-image--calender-modal"
							/>
							{/* </label> */}
						</div>
					</div>

					<div className="configure-wrapper__one-task">
						<div className="form-group mb-0 mt-3">
							{/* <InputField
								inputType="DATETYPE-DOB-MODAL"
								value={getValue(request, `legal_due_date`, "")}
								className="form-control"
								onChange={(e: any) =>
									setRequest({
										...request,
										legal_due_date: e,
									})
								}
								minDate={
									getValue(request, `frequency_type`, "") !== "ONE_TIME" &&
									tomorrow
								}
								placeholderText={"Enter Upcoming Legal Due Date"}
							/> */}

							<div className="d-flex justify-content-end">
								<button
									className="ascent-button ascent-button--header-buttons ascent-button--primary"
									onClick={handleCancel}
								>
									Cancel
								</button>
								{isLoading ? (
									<button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
										Please wait...
									</button>
								) : (
									// !props.configureID && (
									<button
										className="ascent-button ascent-button--header-buttons ascent-button--secondary"
										onClick={handleSubmit}
										// disabled={props.configureID ? true : false}
									>
										Submit
									</button>
									// )
								)}
							</div>
						</div>
						{/* <div className="form-group">
								<div className="d-flex">
									<img src="" className="img-fluid" />
									<label>Due Date & Time</label>
								</div>
								<InputField
									inputType={"DATETYPE-DOB"}
									value={getValue(request, `legal_due_date`, "")}
									className="form-control"
									onChange={(e: any) =>
										setRequest({
											...request,
											legal_due_date: e,
										})
									}
								/>
							</div> */}
					</div>
				</div>
			</div>

			{/* <div className="d-flex justify-content-between m-3">
				<h3>Configure</h3>
				<div className="user-details-wrapper__cta-btns d-flex justify-content-end mr-4">
					<button
						className="ascent-button ascent-button--header-buttons ascent-button--primary"
						onClick={props.handleModal}
					>
						Cancel
					</button>
					{isLoading ? (
						<button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
							Please wait...
						</button>
					) : (
						<button
							className="ascent-button ascent-button--header-buttons ascent-button--secondary"
							onClick={handleSubmit}
						>
							Submit
						</button>
					)}
				</div>
			</div>

			<div className="m-3">
				<div>
					<Label>Upcoming Legal Due Date</Label>
					<InputField
						inputType={"DATETYPE-DOB"}
						value={getValue(request, `legal_due_date`, "")}
						className="form-control"
						onChange={(e: any) =>
							setRequest({
								...request,
								legal_due_date: e,
							})
						}
					/>
				</div>
				<div>
					<Label>Frequency</Label>
					<div className="d-flex">
						{frequency.map((item: object) => {
							return (
								<div>
									<label>{getValue(item, `label`, "")}</label> &nbsp;
									<input
										type={"radio"}
										checked={
											getValue(item, `value`, "") ===
											getValue(request, `frequency_type`, "")
										}
										onChange={() =>
											setRequest({
												...request,
												frequency_type: getValue(item, `value`, ""),
											})
										}
									/>
									&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								</div>
							);
						})}
					</div>
				</div>
				<br />
				{getValue(request, `frequency_type`, "") === "RECURRING" && (
					<div>
						<div className="d-flex">
							{activity_range.map((item: object) => {
								return (
									<div>
										<label>{getValue(item, `label`, "")}</label> &nbsp;
										<input
											type={"radio"}
											checked={
												getValue(item, `value`, "") ===
												getValue(request, `new_activity_range`, "")
											}
											onChange={() =>
												setRequest({
													...request,
													new_activity_range: getValue(item, `value`, ""),
												})
											}
										/>
										&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
									</div>
								);
							})}
						</div>
						<br />

						{getValue(request, "new_activity_range", "") === "DAILY" && (
							<div>
								<label>Every Day(s)</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									options={days}
									onChange={(e: object) =>
										setRequest({
											...request,
											once_in_every: getValue(e, `value`, ""),
										})
									}
								/>
							</div>
						)}
						{getValue(request, "new_activity_range", "") === "WEEKLY" && (
							<div>
								<label>Every Weeks(s)</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									options={days}
									onChange={(e: object) =>
										setRequest({
											...request,
											once_in_every: getValue(e, `value`, ""),
										})
									}
								/>
								<label>On Day(s)</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									options={daysObject}
									onChange={(e: object) =>
										setRequest({
											...request,
											on_day: getValue(e, `value`, ""),
										})
									}
								/>
							</div>
						)}
						{getValue(request, "new_activity_range", "") === "MONTHLY" && (
							<div>
								<label>Once in Every Month(s)</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									options={months}
									onChange={(e: object) =>
										setRequest({
											...request,
											once_in_every: getValue(e, `value`, ""),
										})
									}
								/>
								<label>On Day(s)</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									options={days}
									onChange={(e: object) =>
										setRequest({
											...request,
											on_day: getValue(e, `value`, ""),
										})
									}
								/>
							</div>
						)}
						{getValue(request, "new_activity_range", "") === "YEARLY" && (
							<div>
								<label>Once in Every Year(s)</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									options={days}
									onChange={(e: object) =>
										setRequest({
											...request,
											once_in_every: getValue(e, `value`, ""),
										})
									}
								/>
								<label>On Month(s)</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									options={months}
									onChange={(e: object) =>
										setRequest({
											...request,
											on_month: getValue(e, `value`, ""),
										})
									}
								/>
								<label>On Day(s)</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									options={days}
									onChange={(e: object) =>
										setRequest({
											...request,
											on_day: getValue(e, `value`, ""),
										})
									}
								/>
							</div>
						)}
					</div>
				)}
			</div> */}
		</Modal>
	);
};

export default ConfigurePopup;
